import {
  CREATE_ARTICLE_FAILURE,
  CREATE_ARTICLE_REQUEST,
  CREATE_ARTICLE_SUCCESS,
  GET_ARTICLE_BY_CHAPTER_ID_FAILURE,
  GET_ARTICLE_BY_CHAPTER_ID_REQUEST,
  GET_ARTICLE_BY_CHAPTER_ID_SUCCESS,
  RESET_ARTICLE_VARIABLES,
} from "./ActionType";

const initialState = {
  createArticleResult: {},
  article: {},
  loadingCreate: false,
  loadingGet: false,
  errorCreate: null,
  errorGet: null,
};

export const articleReducer = (state = initialState, action) => {
  switch (action.type) {
    // === CREATE ARTICLE ===
    case CREATE_ARTICLE_REQUEST:
      return {
        ...state,
        loadingCreate: true,
        errorCreate: null,
      };
    case CREATE_ARTICLE_SUCCESS:
      return {
        ...state,
        loadingCreate: false,
        createArticleResult: action.payload,
      };
    case CREATE_ARTICLE_FAILURE:
      return {
        ...state,
        loadingCreate: false,
        errorCreate: action.payload,
      };
    case RESET_ARTICLE_VARIABLES:
      return {
        ...state,
        createArticleResult: {},
        loadingCreate: false,
        errorCreate: null,
      };
    // === GET ARTICLE BY CHAPTER ID ===
    case GET_ARTICLE_BY_CHAPTER_ID_REQUEST:
      return {
        ...state,
        loadingGet: true,
        errorGet: null,
      };
    case GET_ARTICLE_BY_CHAPTER_ID_SUCCESS:
      return {
        ...state,
        loadingGet: false,
        article: action.payload,
      };

    case GET_ARTICLE_BY_CHAPTER_ID_FAILURE:
      return {
        ...state,
        loadingGet: false,
        errorGet: action.payload,
      };

    default:
      return state;
  }
};
